import { Inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { ScriptModel } from '@uzurv/clara';
import { APP_CONFIGURATION, AppConfiguration } from 'projects/uzurv/src/app/app-configuration';
import { Observable } from 'rxjs';

@Injectable()
export class MapsSdkResolver implements Resolve<Observable<ScriptModel>> {
  version = '3.64';
  libraries = ['drawing', 'geometry', 'places'];

  constructor(@Inject(APP_CONFIGURATION) private appConfiguration: AppConfiguration) {}

  resolve() {
    setOptions({
      v: this.version,
      key: this.appConfiguration.googleMapsApiKey,
      libraries: this.libraries
    });

    void importLibrary('drawing');
    void importLibrary('geometry');
    void importLibrary('places');

    return null;
  }
}
